import HeroHeading from '../Headings/HeroHeading'
import HeroDescription from '../Headings/HeroDescription'
import BookACallButton from '../Buttons/Specials/BookACallButton'
import RightIcon from '../../Icons/coaching/funnel/right-icon.svg'
import ResultsDrivenModal from '../Modals/ResultsDrivenModal'

function HeroSectionVersion2() {
    const image_url = '/assets/landing/result-driven-hero.png'

    return (
        <div className="m-auto max-w-full w-[1200px] px-4 md:px-0 xl:px-6 relative flex flex-col md:flex-row items-center md:items-center">
            <div className="w-full md:w-6/12">
                <div className="space-y-6">
                    <div className="m-auto md:text-left text-center">
                        <HeroHeading>
                            Boost Your{' '}
                            <span className="olm-gradient-text">Real</span>{' '}
                            <br />
                            <span className="olm-gradient-text">
                                Estate Marketing
                            </span>
                        </HeroHeading>
                    </div>
                    <div className="max-w-full md:w-10/12 space-y-4 md:space-y-2 md:py-2">
                        <div className="text-center md:text-left">
                            <HeroDescription>
                                We specialize in providing real estate
                                professionals with precision-targeted direct
                                mail solutions that are not only effective but
                                are crafted to maximize your return on
                                investment.
                            </HeroDescription>
                        </div>

                        <div className="md:hidden w-full md:w-6/12 justify-center md:justify-end">
                            <img
                                src={image_url}
                                alt="Result Driven"
                                className="w-full h-auto md:-mt-20"
                            />
                        </div>

                        <div className="flex text-lg items-start space-x-2 ">
                            <div>
                                {' '}
                                <span className="text-orange-500 mt-1">
                                    {' '}
                                    <RightIcon />{' '}
                                </span>
                            </div>
                        </div>

                        <div className="w-96 max-w-full space-y-4">
                            <BookACallButton Modal={ResultsDrivenModal} />
                            <div className="text-center text-lg">
                                <p className="font-bold">
                                    Need help getting started?
                                </p>
                                <p>Book a call with our Marketing Coaches</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="hidden md:flex w-full md:w-6/12 justify-center md:justify-end">
                <img
                    src={image_url}
                    alt="Affiliate Image"
                    className="w-full h-auto md:-mt-20"
                />
            </div>
        </div>
    )
}

export default HeroSectionVersion2
